/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Watchpage_IntroInputs */

const en_fw_watchpage_intro = /** @type {(inputs: Fw_Watchpage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every legal way to watch the Firefly Wedding anime, grouped by region, plus the weekly air times and where to read the original manga.`)
};

const zh_fw_watchpage_intro = /** @type {(inputs: Fw_Watchpage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按地区整理萤火之嫁动画的所有正版观看渠道，附每周播出时间与原作漫画阅读入口。`)
};

/**
* | output |
* | --- |
* | "Every legal way to watch the Firefly Wedding anime, grouped by region, plus the weekly air times and where to read the original manga." |
*
* @param {Fw_Watchpage_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_watchpage_intro = /** @type {((inputs?: Fw_Watchpage_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Watchpage_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_watchpage_intro(inputs)
	return zh_fw_watchpage_intro(inputs)
});
export { fw_watchpage_intro as "fw.watchpage.intro" }